import styled, { css } from 'styled-components';
// content_accuracy, technical_issues, inappropriate_content, course_material_feedback, other_feedback
export const choosingOptionsMocks = {
  1: {
    titleText: 'ReportModal.ContentAccuracy',
    type: 'content_accuracy',
  },
  2: {
    titleText: 'ReportModal.TechnicalIssues',
    type: 'technical_issues',
  },
  3: {
    titleText: 'ReportModal.FeedbackCourseMaterial',
    type: 'course_material_feedback',
  },
  4: {
    titleText: 'ReportModal.Other',
    type: 'other_feedback',
  },
};

export const TextArea = styled.textarea`
  ${({ theme: { colors } }) => css`
    padding: 24px;
    outline-color: transparent;
    border: none;

    height: 130px;
    width: 800px;

    color: ${colors.white[100]};
    background-color: ${colors.white[10]} !important;
    user-select: none;
    resize: none;
  `}
`;
